import api from './api';
import {
  TableData,
  TableDataHistory,
  TableDataQuery,
  TableDataResponse,
} from '../types/tableData.types';

export interface CopyToTableRequest {
  targetTableId: string;
  fieldMapping: Record<string, string>;
  customData?: Record<string, any>;
  deleteFromSource?: boolean;
}

export const TableDataService = {
  getTableData: async (tableId: string, query?: TableDataQuery): Promise<TableDataResponse> => {
    const params: any = { ...query };

    if (params.filter) {
      params.filter = JSON.stringify(params.filter);
    }
    if (params.sort) {
      params.sort = JSON.stringify(params.sort);
    }

    const response = await api.get<TableDataResponse>(`/tables/${tableId}/data`, {
      params,
    });
    return response.data;
  },

  bulkCreateTableData: async (
    tableId: string,
    rows: Record<string, any>[],
  ): Promise<{ success: number; failed: number; errors: { row: number; message: string }[] }> => {
    const response = await api.post(`/tables/${tableId}/data/bulk`, { rows });
    return response.data;
  },

  bulkDeleteTableData: async (
    tableId: string,
    ids: string[],
  ): Promise<{ deleted: number }> => {
    const response = await api.post(`/tables/${tableId}/data/bulk-delete`, { ids });
    return response.data;
  },

  getTableDataById: async (tableId: string, dataId: string): Promise<TableData> => {
    const response = await api.get<TableData>(`/tables/${tableId}/data/${dataId}`);
    return response.data;
  },

  createTableData: async (tableId: string, data: any): Promise<TableData> => {
    const response = await api.post<TableData>(`/tables/${tableId}/data`, { data });
    return response.data;
  },

  updateTableData: async (tableId: string, dataId: string, data: any): Promise<TableData> => {
    const response = await api.put<TableData>(`/tables/${tableId}/data/${dataId}`, { data });
    return response.data;
  },

  deleteTableData: async (tableId: string, dataId: string): Promise<void> => {
    await api.delete(`/tables/${tableId}/data/${dataId}`);
  },

  getTableDataHistory: async (tableId: string, dataId: string): Promise<TableDataHistory[]> => {
    const response = await api.get<TableDataHistory[]>(`/tables/${tableId}/data/${dataId}/history`);
    return response.data;
  },

  copyToTable: async (
    sourceTableId: string,
    dataId: string,
    copyData: CopyToTableRequest
  ): Promise<TableData> => {
    const response = await api.post<TableData>(
      `/tables/${sourceTableId}/data/${dataId}/copy`,
      copyData
    );
    return response.data;
  },

};



